import * as React from 'react';
import { useSelector } from 'react-redux';

import { Author } from '../../../components/Author';
import { getReviewById } from '../../../selectors/reviews';

interface IAuthorContainerProps {
  reviewId: string;
}

export function AuthorContainer({ reviewId }: IAuthorContainerProps) {
  const { user, rating, date } = useSelector(getReviewById(reviewId));

  return <Author name={user.name} rating={rating} date={date} />;
}
